module.exports = {"TXTCLI_Play":{"id":"TXTCLI_Play","defaultMessage":"Játék","flags":["TRACK"],"track":"Play"}}